/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SiteConfigFacade } from '@qwyk/portals/siteconfig';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { environment } from '@qwyk/portals/environment';

@Injectable({
    providedIn: 'root',
})
export class ResendVerificationEmailServiceService {
    constructor(
        private http: HttpClient,
        private siteConfig: SiteConfigFacade
    ) {}

    public resendVerificationEmail(email: string): Observable<any> {
        return this.siteConfig.organization$.pipe(
            switchMap(organization =>
                this.http
                    .post<any>(
                        `${environment.backendServer}/api/portals/auth/confirm-email/resend`,
                        { organization_id: organization.organization_id, email }
                    )
                    .pipe(first())
            )
        );
    }
}
